import React from 'react';

export function ErrorRoute(): JSX.Element {
    return (
        <div>404 Not Found</div>
    );
}
